//扩展vue
import axios from 'axios'
import AppSetting from '../../AppSetting';
import loginService from './loginService';

let appid;
const hostname = location.hostname;
if (hostname == 'www.medcircle.cn') { //或者用户是用微信内置浏览器打开的
  appid = 'wxe892f071e36444ad'; //生产

} else {
  appid = 'wxc94beeaf4f4c9d5e'; //生产

}



/**
 * 随机产生num个字母字符串
 */
function getNonceStr(num) {
  var result = "";
  for (var i = 0; i < num; i++) {
    var ranNum = Math.ceil(Math.random() * 25);
    result += String.fromCharCode(97 + ranNum);
  }
  return result.toString();
}

/**
 * 获取微信签名
 * @param {Object} timestamp
 * @param {Object} nonceStr
 * @param {Object} curUrl
 */
function getSingture(nonceStr, timestamp, curUrl) {
  return new Promise((resolve, reject) => {
    axios({
      method: 'post',
      data: {
        noncestr: nonceStr,
        timestamp: timestamp,
        url: curUrl,
      },
      url: AppSetting.baseUrl + '/common/weixin/jsapi_ticket'
    }).then(({
      data
    }) => {
      console.log(data);
      resolve(data)
    });
  })
}
/**
 *微信认证
 */
function wxConfig() {

  let timestamp = new Date().getTime() + "";
  timestamp = timestamp.substring(0, 10);
  const nonceStr = getNonceStr(16);
  const curUrl = location.href.split('#')[0];

  getSingture(nonceStr, timestamp, curUrl)
    .then((data) => {

      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: appid, // 必填，公众号的唯一标识
        timestamp: timestamp, // 必填，生成签名的时间戳
        nonceStr: nonceStr, // 必填，生成签名的随机串
        signature: data.ticket, // 必填，签名，见附录1
        jsApiList: [
          "checkJsApi",
          "scanQRCode",
          "translateVoice",
          "onMenuShareTimeline",
          "onMenuShareAppMessage",
          "openLocation",
          "getBrandWCPayRequest",
          "getLocation",
          "openLocation",
          "getNetworkType"
        ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
      });
    })
}

function share(title, desc, share_img, curUrl, id, firends, type) {
  wx.ready(function () { //需在用户可能点击分享按钮前就先调用
    //转发给好友
    console.log(title, desc, share_img, curUrl);
    // wx.updateAppMessageShareData({
    //   title: title, // 分享标题
    //   desc: desc, // 分享描述
    //   link: curUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    //   imgUrl: share_img, // 分享图标
    //   success: function () {
    //     // 设置成功
    //     alert('成功')
    //   },
    // });
    // wx.updateTimelineShareData({
    //   title: title, // 分享标题
    //   desc: desc, // 分享描述
    //   link: curUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    //   imgUrl: share_img, // 分享图标
    //   success: function () {
    //     // 设置成功
    //     alert('分享成功')
    //   }
    // });

    wx.onMenuShareAppMessage({
      title: title, // 分享标题
      desc: desc, // 分享描述
      link: curUrl,
      imgUrl: share_img, // 分享图标
      type: 'link', // 分享类型,music、video或link，不填默认为link
      dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
      success: async function () {
        // console.log('视频id',id);
        let wxuser =await loginService.getLoginUser();
        if (type == 'video') {
          localStorage.setItem('share', id);
          // localStorage.setItem('live_share',id);
          axios({
            method: 'post',
            data: {
              uid: wxuser.uId,
              vid: id
            },
            url: AppSetting.baseUrl + '/video/share'
          }).then(({
            data
          }) => {
            console.log(data);
            // resolve(data)
          });
        } else {
          localStorage.setItem('live_share', id);
          // localStorage.setItem('live_share',id);
          axios({
            method: 'post',
            data: {
              sid: wxuser.uId,
              lid: id,
              sltype: 4
            },
            url: AppSetting.baseUrl + '/live/appointment'
          }).then(({
            data
          }) => {
            console.log(data);
            // resolve(data)
          });
        }


      },
      cancel: function () {
        // localStorage.setItem('share','');
        // 用户取消分享后执行的回调函数
      }
    });
    //分享到朋友圈
    wx.onMenuShareTimeline({
      title: firends, // 分享标题
      desc: desc, // 分享描述
      link: curUrl,
      imgUrl: share_img, // 分享图标
      type: 'link', // 分享类型,music、video或link，不填默认为link
      success:async function () {
        // console.log('视频id',id);
        let wxuser =await loginService.getLoginUser();
        if (type == 'video') {
          localStorage.setItem('share', id);
          // localStorage.setItem('live_share',id);
          axios({
            method: 'post',
            data: {
              uid: wxuser.uId,
              vid: id
            },
            url: AppSetting.baseUrl + '/video/share'
          }).then(({
            data
          }) => {
            console.log(data);
            // resolve(data)
          });
        } else {
          localStorage.setItem('live_share', id);
          // localStorage.setItem('live_share',id);
          axios({
            method: 'post',
            data: {
              sid: wxuser.uId,
              lid: id,
              sltype: 4
            },
            url: AppSetting.baseUrl + '/live/appointment'
          }).then(({
            data
          }) => {
            console.log(data);
            // resolve(data)
          });
        }
      },
      cancel: function () {
        // localStorage.setItem('share','');
        // 用户取消分享后执行的回调函数
      }
    });
  });
}

function scan() {
  return new Promise((resolve, reject) => {
    wx.ready(function () {
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: function (res) {
          var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
          resolve(result);
        },
        fail: function (err) {
          // alert(err);
        }
      });
    })
  })
}

export default {
  wxConfig,
  share,
  scan
};


// WEBPACK FOOTER //
// ./src/plugin/extendFn/wxFn.js